.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-width: var(--form-max);
}

.label {
  color: var(--ink);
  font: var(--t-body-strong);
}

.input {
  display: flex;
  align-items: center;
  width: 12rem;
  height: var(--control-height);
  padding: 0 var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
  font-variant-numeric: tabular-nums;
  cursor: text;
}

.input[data-focus-within] {
  outline: var(--focus-ring);
  outline-offset: 0;
  border-color: var(--brand);
}

.field[data-invalid] .input {
  border-color: var(--status-error-fg);
}

.field[data-disabled] .input {
  background: var(--wash);
  color: var(--pencil);
}

.segment {
  padding: 0 1px;
  border-radius: var(--radius-tag);
  outline: none;
}

.segment[data-placeholder],
.segment[data-type='literal'] {
  color: var(--pencil);
}

.segment[data-focused] {
  background: var(--brand);
  color: var(--on-brand);
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

/* Errors are stated in words, in ink; danger red is reserved for clinical danger. */
.error {
  color: var(--ink);
  font: var(--t-small);
  font-weight: 600;
}
